import BaseUtil from "../../util/BaseUtil";
import UserTypeUtil from "../../util/UserTypeUtil";

const type = `@@ActionType/UPDATE@${__filename}`;

const fileStatusMap = {
    NORMAL: {
        code: "normal",
        display: "正常",
    },
    CANCEL: {
        code: "cancel",
        display: "已注销",
    },
};

const userStatusMap = {
    ALL: {
        code: "ALL",
        display: "全部",
    },
    // INIT: {
    //     code: "INIT",
    //     display: "未录", // 档案未任何发生编辑
    // },
    INVITED: {
        code: "INVITED",
        display: "已邀请", // 邀请后保存状态到数据库
    },
    // DONE: {
    //     code: "DONE",
    //     display: "已填写", // 编辑档案后保存到数据库
    // },
    INCOMPLETE: {
        code: "INCOMPLETE",
        display: "未完整", // 根据档案填写字段是否必填且已填
    },
    AUDIT_PENDING: {
        code: "AUDIT_PENDING",
        display: "审核中", // 根据审核状态判断
    },
};


const initState = {
    initializing: true, // 初始化
    selectedUnitIds: null, // 选中的科室的ids
    selectedUserTypes: [], // 选中的人员类别
    unitsMap: null,
    selectedStatus: fileStatusMap.NORMAL.code, // 选中的状态
    selectedInviteStatus: userStatusMap.ALL.code, // 选中的填写状态
    keyword: "",
    selectedHospitalIds: ["ALL"],
    selectedDistrictIds: ["ALL"],
    groups: [], // 字段组
    items: [], // 字段 先加载再传给子组件
    dicts: [],

    filterData: null, // 筛选的数据
    filterDisplay: null, // 过滤器展示信息

    users: [], // 查到的人员
    userTableLoading: false, // 表格加载
    checkedUsers: [], // 选中的人员
    customColumn: null, // 自定义显示项

    fieldSettingVisible: false, // 自定义字段设置可见
    fieldSettingSaving: false, // 自定义字段设置提交保存

    fileDetailVisible: false, // 档案详情可见
    fileDetailUser: null, // 档案详情用户

    fileImportVisible: false, // 批量导入档案可见

    pageable: {
        limit: 30,
        current: 1,
    },

    pendingCount: 0, // 待审核数量

    inviteFieldsModalVisible: false,
};

const [viewModel, update, reset] = BaseUtil.getViewModel(initState, type);

export {
    update,
    reset,
    fileStatusMap,
    userStatusMap,
};
export default viewModel;
